import { forwardRef } from "react"
import { ListItemIcon, ListItemText, MenuItem } from "@mui/material"
import { interactiveStateStyles } from "lib/@components/interactive-state-styles"

export const SwitcherMenuItem = forwardRef(function SwitcherMenuItem(
    { id, index, dataCy, icon, label, accessibleLabel, onSelect, ...props },
    ref
) {
    return (
        <MenuItem
            ref={ref}
            id={id}
            role="menuitem"
            aria-label={accessibleLabel}
            // The Bound wrapper hides the items from MUI Menu's own autoFocusItem, so the
            // first item must claim focus itself; FocusTrap leaves it alone once focused
            autoFocus={index === 0}
            data-cy={dataCy}
            onClick={onSelect}
            sx={[interactiveStateStyles, { minHeight: 56, px: 1.5, borderRadius: 1 }]}
            {...props}
        >
            <ListItemIcon sx={{ minWidth: "auto", mr: 1, display: "inline-flex", alignItems: "center" }}>
                {icon}
            </ListItemIcon>
            <ListItemText
                primary={label}
                primaryTypographyProps={{ component: "span", variant: "subtitle1", noWrap: true }}
            />
        </MenuItem>
    )
})
